import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.tokenValue;

  if (token) {
    const cloned = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        'X-Locale': 'en',
        'X-Locale-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
        'X-Client-Locale': 'en',
      },
    });
    return next(cloned);
  }

  return next(req);
};
